import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { useAuth } from "../common/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    if (!isProfileOpen) return undefined;

    const closeProfileMenu = (event) => {
      if (!profileMenuRef.current?.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsProfileOpen(false);
    };

    document.addEventListener("mousedown", closeProfileMenu);
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.removeEventListener("mousedown", closeProfileMenu);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isProfileOpen]);

  const handleSignOut = () => {
    setIsProfileOpen(false);
    logout();
    navigate("/login");
  };

  const profileName = user?.userName || "Account";
  const profileInitial = profileName.trim().charAt(0).toUpperCase() || "U";
  const isDashboard = location.pathname.startsWith("/dashboard");
  const isSubscribe = location.pathname.startsWith("/subscribe");
  const isProfile = location.pathname.startsWith("/profile");
  const isFyersAccessToken = location.pathname.startsWith("/fyers-access-token");
  const isCompactHeader = isDashboard || isSubscribe || isProfile || isFyersAccessToken;

  return (
    <header className={`header fixed-header${isCompactHeader ? " header--compact" : ""}`}>
      <nav className="nav-container">

        {/* LEFT SIDE (LOGO ONLY) */}
        <div className="left-nav">
          <Link to="/" className="logo-container">
            <img
              src="/assets/images/noptionwave-logo-1.png"
              className="logo-image"
              alt="noptionwave logo"
            />
          </Link>
        </div>

        <div id="strategy-header-slot" className="strategy-header-slot" />

        {/* RIGHT SIDE (HOME + LOGIN/SIGNUP) */}
        <ul className="nav-links right-links">
          <li>
            <Link to="/">Home</Link>
          </li>

          {user ? (
            <li className="profile-menu" ref={profileMenuRef}>
              <button
                className="profile-menu-trigger"
                type="button"
                aria-label="Open profile menu"
                aria-haspopup="menu"
                aria-expanded={isProfileOpen}
                onClick={() => setIsProfileOpen((isOpen) => !isOpen)}
              >
                <span className="profile-avatar" aria-hidden="true">{profileInitial}</span>
                <i className="fa fa-chevron-down profile-menu-chevron" aria-hidden="true" />
              </button>

              {isProfileOpen && (
                <div className="profile-dropdown" role="menu" aria-label="Profile menu">
                  <div className="profile-dropdown__identity">
                    <span className="profile-avatar profile-avatar--large" aria-hidden="true">{profileInitial}</span>
                    <div>
                      <strong>{profileName}</strong>
                      <span>{user?.email || "Email not available"}</span>
                    </div>
                  </div>
                  <div className="profile-dropdown__divider" />
                  <button className="profile-logout-button" type="button" role="menuitem" onClick={handleSignOut}>
                    <i className="fa fa-sign-out" aria-hidden="true" />
                    Logout
                  </button>
                </div>
              )}
            </li>
          ) : (
            <>
              <li>
                <Link to="/login">Login</Link>
              </li>
              <li>
                <Link to="/signup">Signup</Link>
              </li>
            </>
          )}
        </ul>

      </nav>
    </header>
  );
}
